module.exports = __webpack_public_path__ + "assets/8b238ec92036fe977f013f8db7ab2771.png";